import cssVariables from 'tfs.css-variables'

export default {
  '@keyframes fadeIn': {
    from: {
      opacity: '0',
    },
    to: {
      opacity: '1',
    },
  },
  header: {
    padding: '1em 8em',
    textAlign: 'center',
  },
  description: {
    padding: '0 8em 1em',
  },
  title: {
    color: cssVariables.colorWarning,
  },
  subTitle: {
    color: cssVariables.colorWarning,
    margin: '4rem 0 0',
  },
  icon: {
    color: cssVariables.colorWarning,
    fontSize: '2em',
    lineHeight: '2em',
  },
  content: {
    borderRadius: '0 0 1em 1em',
    backgroundColor: cssVariables.colorWhiteHover,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    padding: '0 8em',

    '& > div:nth-child(3)': {
      paddingTop: '1em',
    },
    '&:nth-child(n+2)': {
      paddingTop: '1.5em',
      paddingBottom: '1.5em',
    },

    '&:last-child': {
      paddingBottom: '2.5em',
    },

    '&:nth-child(n+3)': {
      borderTop: `thin solid ${cssVariables.colorGrayE}`,
    },
  },
  flight: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '18em',
    textAlign: 'right',
  },
  paddingTop: {
    paddingTop: '1em',
  },
}
